import React, { useState } from "react";
import { Table } from "react-bootstrap";
import moment from "moment";
import { FRIENDLY_DATETIME_FORMAT } from "../../constants";
import { StreamEvent } from "./useEventStream";
import EventStreamDetail from "./EventStreamDetail";

type EventStreamListProps = {
    events: StreamEvent[];
    isConnected: boolean;
}

const EventStreamList: React.FC<EventStreamListProps> = ({ events, isConnected }) => {
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const toggleRow = (index: number) => {
        setExpandedIndex(prev => (prev === index ? null : index));
    };

    if (isConnected && events.length === 0) {
        return <p style={{ color: "#aaa", padding: "10px" }}>Connected – waiting for events…</p>;
    }

    if (events.length === 0) {
        return null;
    }

    return (
        <Table striped hover size="sm" style={{ fontSize: "0.85em" }}>
            <thead>
                <tr>
                    <th>Timestamp</th>
                    <th>Event Type</th>
                    <th>User ID</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {events.map((event, index) => (
                    <React.Fragment key={index}>
                        <tr
                            onClick={() => toggleRow(index)}
                            style={{ cursor: "pointer" }}
                        >
                            <td>{moment(event.timestamp_initiated).format(FRIENDLY_DATETIME_FORMAT)}</td>
                            <td>{event.action}</td>
                            <td>{event.user_id}</td>
                            <td style={{ textAlign: "right" }}>
                                {expandedIndex === index ? "▲" : "▼"}
                            </td>
                        </tr>
                        {expandedIndex === index && (
                            <tr>
                                <td colSpan={4}>
                                    <EventStreamDetail event={event} />
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default EventStreamList;
